import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../button/Button';
var ModalTriggerPropTypes = {
  onClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string
};
var ModalTriggerDefaultProps = {
  buttonText: 'Open Modal'
};
var ModalTrigger = function ModalTrigger(_ref) {
  var onClick = _ref.onClick,
    buttonText = _ref.buttonText;
  return /*#__PURE__*/React.createElement(Button, {
    variant: "muted",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", null, buttonText));
};
ModalTrigger.propTypes = ModalTriggerPropTypes;
ModalTrigger.defaultProps = ModalTriggerDefaultProps;
export default ModalTrigger;